<template>
  <div
    v-click-outside="hiddenDropDown"
    ref="infiniteListRef"
    class="drop-container"
    @click="toggleDropdown"
  >
    <label
      class="dropdown-label w-full"
      :class="selectedValue ? 'position-top text-[14px]' : 'position-center'"
    >
      {{ $t(label) }}</label
    >
    <div class="display-value leading-[50px]">{{ displayValue }}</div>
    <span class="drop-list-icon"
      ><img :class="{ 'rotate-x': isShowDropList }" src="/img/drop-icon.svg"
    /></span>
    <ul class="drop-list" v-show="isShowDropList">
      <li
        class="drop-item cursor-pointer"
        :class="{ 'selected-item': selectedValueProps === item.id }"
        v-for="(item, index) in options"
        :key="'key' + index"
        @click="selectedValue = item.id"
      >
        {{ item.name }}
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    displayValue: {
      type: String
    },
    selectedValueProps: {
      type: [String, Number],
      default: ""
    }
  },
  data() {
    return {
      isShowDropList: false
    };
  },
  computed: {
    selectedValue: {
      get: function() {
        return this.selectedValueProps;
      },
      set: function(value) {
        this.$emit("updateValueSelected", value);
      }
    }
  },
  mounted() {
    const listElm = this.$refs.infiniteListRef.querySelector("ul");
    listElm.addEventListener("scroll", e => {
      if (listElm.scrollTop + listElm.clientHeight >= listElm.scrollHeight) {
        this.loadMore();
      }
    });
  },
  methods: {
    toggleDropdown() {
      this.isShowDropList = !this.isShowDropList;
    },
    hiddenDropDown() {
      this.isShowDropList = false;
    },
    loadMore() {
      this.$emit("fetchMoreOptions");
    }
  }
};
</script>
<style lang="scss" scoped>
::-webkit-scrollbar {
  appearance: none;
  width: 10px;
  height: 10px;
}

::-webkit-scrollbar-thumb {
  background: #9a9a9a;
  border-radius: 25px;
}
.drop-container {
  z-index: 10;
  position: relative;
  .dropdown-label {
    position: absolute;
    left: 0;
    color: #3d3d3d;
    font-weight: 400;
  }
  .position-top {
    top: -10px;
  }
  .position-center {
    top: 50%;
    transform: translate(0, -50%);
  }
  .display-value {
    width: 100%;
    padding-right: 35px;
    height: 40px;
    border-bottom: 1px solid #aaaaaa;
    line-height: 40px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  .drop-list-icon {
    position: absolute;
    right: 12px;
    top: 7px;
    .rotate-x {
      transform: rotate(180deg);
    }
  }
  .drop-list {
    top: 46px;
    box-shadow: 0 3px 5px rgba(0, 0, 0, 0.2), 0 1px 18px rgba(0, 0, 0, 0.12),
      0 6px 10px rgba(0, 0, 0, 0.14);
    border-radius: 4px;
    overflow-y: auto;
    max-height: 300px;
    background: #fff;
    width: 100%;
    position: absolute;
    .drop-item {
      border-radius: 4px;
      min-height: 36px;
      line-height: 30px;
      padding: 4px 4px 4px 12px;
      background: #fff;
      color: black;
    }
    .selected-item {
      background: #9c27b0;
      color: #fff;
    }
    .drop-item:hover {
      background: #9c27b0;
      color: #fff;
    }
  }
}
</style>
